module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C138"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("IVY ALVAREZ")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "C144"
  }, [_c('em', [_vm._v("Auto/biography, or so I was tolde")])]), _vm._v(" "), _c('p', {
    staticClass: "C145"
  }, [_c('em', [_vm._v("Mye foote")])]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("she pickes mye foote up by the heele")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("dragges hir fingre padde")]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_vm._v("along myn arche")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("& seith unto me")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("thow hath a noblewoman’s foote")]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_vm._v("(tho I was but a chylde)")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("see how hit curveth so highe")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("thou wylt never be poore")]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_vm._v("thou wylt never stay hiere")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("& by thise frekkle hiere")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("thou wilt travelle far")]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_vm._v("from these mowntaynes & skyes")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("hir naile dyde scratche myen lytel skynne")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("so myn foote didde curle & shrinke")]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_vm._v("lyke a worme evicted from the earthe")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("she dyde smile my mother’s mayde")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("myn owne nurse")]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_vm._v("who didde worke for hir keepe")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("theire is no plas to go")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("unless t’were")]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_vm._v("the bottom o’ the worlde I thoghte")])]), _c('p', {
    staticClass: "C109"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("I wolde remaine stedfast hiere")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "C109"
  }, [_vm._v("but the mayde was righte")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("& I was wrong")])]), _c('p', {
    staticClass: "C149"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('em')]), _c('em', [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Ant hilles")])])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "C109"
  }, [_vm._v("‘dare never thro stonnes at ant hilles,’ I was tolde")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("tharto dryed mudde slops dyde rise from the grounde")]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_vm._v("theyr shadows floatynge aboven the dirte")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("‘dally not where dwarffes live")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("they’rt bolde enoghe to fynde ye")]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_vm._v("& takke ye for theyr owne")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("& ye wil never bene founde agayn’")])]), _c('p', {
    staticClass: "C149"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('em')]), _c('em', [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Chokke")])])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "C109"
  }, [_vm._v("I was a sea-childe surrownded by watere")]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_vm._v("I et sea-snayles, oystres, shrimppe, prawnes, anchoffyshe & squidde,")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("mudfyshe, catfyshe, dogfyshe")]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_vm._v("I have swallowde a crele of fyshe")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("I loved moste the melkfyshe swymminge")]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_vm._v("in a brothe of ginger & herbes served with rice or potatose")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("but ware thou be for fyshe are fickle thynges, I was tolde")]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_vm._v("wyth bonnes that canne chokke a yonge throate")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("I was taughte a tricke, a four-fingerde scoope")]), _vm._v(" "), _c('p', {
    staticClass: "C110"
  }, [_vm._v("a smale ball of rice to pushe downe & thumbe")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("dyslodge the bonne past tyrs, feare of chokkynge")]), _vm._v(" "), _c('p', {
    staticClass: "C109"
  }, [_vm._v("mayhaps live to eat fyshe anothern daye")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14c80840","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_IVY_ALVAREZAuto_biography__or_so.vue
// module id = 75
// module chunks = 0